import { useEffect } from 'react';

var contextSent = false;

export function GitBookContext({ message }) {
    useEffect(
        function() {
            if (contextSent) return;
            var msg = message || 'I need help with Private Panels';
            var timeoutId = null;
            var attachedBtn = null;
            var observer = null;

            function onButtonClick() {
                if (contextSent) return;

                contextSent = true;

                timeoutId = setTimeout(function() {
                    if (typeof window.GitBook !== 'function') return;
                    window.GitBook('navigateToAssistant');
                    window.GitBook('postUserMessage', msg);
                }, 500);
            }

            function attachListener(btn) {
                attachedBtn = btn;
                btn.addEventListener('click', onButtonClick);
            }

            var btn = document.getElementById('gitbook-widget-button');
            if (btn) {
                attachListener(btn);
            } else {
                observer = new MutationObserver(function() {
                    var btn = document.getElementById('gitbook-widget-button');
                    if (btn) {
                        observer.disconnect();
                        attachListener(btn);
                    }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }

            return function() {
                if (observer) observer.disconnect();
                if (timeoutId) clearTimeout(timeoutId);
                if (attachedBtn) attachedBtn.removeEventListener('click', onButtonClick);
            };
        },
        [message]
    );

    return null;
}
